export default [
  {
    "date": "1 feb",
    "state": "Iowa",
    "delegates_r": "27",
    "delegates_d": "44",
    "superdelegates_r": "3",
    "superdelegates_d": "8",
    "state_short": "IA",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "23",
    "Bernie Sanders": "21",
    "Donald Trump": "7",
    "Ben Carson": "3",
    "Ted Cruz": "8",
    "Jeb Bush": "1",
    "Carly Fiorina": "1",
    "John Kasich": "1",
    "Rand Paul": "1",
    "Marco Rubio": "7",
    "Mike Huckabee": "1",
    "kind": "C",
    "party": "B",
    "text": "Demokraten Martin O'Malley och republikanen Mike Huckabee avslutade sina kandidaturer efter svaga valresultat i Iowa."
  },
  {
    "date": "9 feb",
    "state": "New Hampshire",
    "delegates_r": "20",
    "delegates_d": "24",
    "superdelegates_r": "3",
    "superdelegates_d": "8",
    "state_short": "NH",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "9",
    "Bernie Sanders": "15",
    "Donald Trump": "11",
    "Ben Carson": "",
    "Ted Cruz": "3",
    "Jeb Bush": "3",
    "Carly Fiorina": "",
    "John Kasich": "4",
    "Rand Paul": "",
    "Marco Rubio": "2",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": "Bernie Sanders vann över Hillary Clinton och Donald Trump dominerade bland de republikanska kandidaterna."
  },
  {
    "date": "20 feb",
    "state": "Nevada",
    "delegates_r": "",
    "delegates_d": "35",
    "superdelegates_r": "",
    "superdelegates_d": "8",
    "state_short": "NV",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "20",
    "Bernie Sanders": "15",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "D",
    "text": "– Några kan ha tvekat, men vi själva tvekade aldrig, <a href='http://www.svt.se/nyheter/utrikes/clinton-vinnare-i-nevada'>sa Clinton</a> efter vinsten i delstaten."
  },
  {
    "date": "20 feb",
    "state": "South Carolina",
    "delegates_r": "50",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "SC",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "50",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "R",
    "text": "Trump fick en tredjedel av rösterna i South Carolina, men delstatens regler för delegatfördelning gav honom full pott – samtliga delegater tillföll Trump."
  },
  {
    "date": "23 feb",
    "state": "Nevada",
    "delegates_r": "30",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "NV",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "14",
    "Ben Carson": "1",
    "Ted Cruz": "6",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "1",
    "Rand Paul": "",
    "Marco Rubio": "7",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "R",
    "text": ""
  },
  {
    "date": "27 feb",
    "state": "South Carolina",
    "delegates_r": "",
    "delegates_d": "59",
    "superdelegates_r": "",
    "superdelegates_d": "6",
    "state_short": "SC",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "39",
    "Bernie Sanders": "14",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "D",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Alabama",
    "delegates_r": "50",
    "delegates_d": "53",
    "superdelegates_r": "",
    "superdelegates_d": "7",
    "state_short": "AL",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "44",
    "Bernie Sanders": "9",
    "Donald Trump": "36",
    "Ben Carson": "",
    "Ted Cruz": "13",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "1",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Alaska",
    "delegates_r": "28",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "AK",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "11",
    "Ben Carson": "",
    "Ted Cruz": "12",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "5",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "R",
    "text": "",
    "winner_r": "Ted Cruz"
  },
  {
    "date": "1 mar",
    "state": "Amerikanska Samoa",
    "delegates_r": "",
    "delegates_d": "6",
    "superdelegates_r": "",
    "superdelegates_d": "4",
    "state_short": "AS",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "4",
    "Bernie Sanders": "2",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Arkansas",
    "delegates_r": "40",
    "delegates_d": "32",
    "superdelegates_r": "",
    "superdelegates_d": "5",
    "state_short": "AR",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "22",
    "Bernie Sanders": "10",
    "Donald Trump": "16",
    "Ben Carson": "",
    "Ted Cruz": "15",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "9",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Colorado",
    "delegates_r": "",
    "delegates_d": "66",
    "superdelegates_r": "",
    "superdelegates_d": "13",
    "state_short": "CO",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "25",
    "Bernie Sanders": "41",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Georgia",
    "delegates_r": "76",
    "delegates_d": "102",
    "superdelegates_r": "",
    "superdelegates_d": "15",
    "state_short": "GA",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "73",
    "Bernie Sanders": "29",
    "Donald Trump": "42",
    "Ben Carson": "",
    "Ted Cruz": "18",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "16",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Massachusetts",
    "delegates_r": "42",
    "delegates_d": "91",
    "superdelegates_r": "",
    "superdelegates_d": "25",
    "state_short": "MA",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "46",
    "Bernie Sanders": "45",
    "Donald Trump": "22",
    "Ben Carson": "",
    "Ted Cruz": "4",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "8",
    "Rand Paul": "",
    "Marco Rubio": "8",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Minnesota",
    "delegates_r": "38",
    "delegates_d": "77",
    "superdelegates_r": "",
    "superdelegates_d": "16",
    "state_short": "MN",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "31",
    "Bernie Sanders": "46",
    "Donald Trump": "8",
    "Ben Carson": "",
    "Ted Cruz": "13",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "17",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Oklahoma",
    "delegates_r": "43",
    "delegates_d": "38",
    "superdelegates_r": "",
    "superdelegates_d": "4",
    "state_short": "OK",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "17",
    "Bernie Sanders": "21",
    "Donald Trump": "13",
    "Ben Carson": "",
    "Ted Cruz": "15",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "12",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Tennessee",
    "delegates_r": "58",
    "delegates_d": "67",
    "superdelegates_r": "",
    "superdelegates_d": "9",
    "state_short": "TN",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "44",
    "Bernie Sanders": "23",
    "Donald Trump": "33",
    "Ben Carson": "",
    "Ted Cruz": "16",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "9",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Texas",
    "delegates_r": "155",
    "delegates_d": "222",
    "superdelegates_r": "",
    "superdelegates_d": "30",
    "state_short": "TX",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "147",
    "Bernie Sanders": "75",
    "Donald Trump": "48",
    "Ben Carson": "",
    "Ted Cruz": "104",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "3",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Vermont",
    "delegates_r": "16",
    "delegates_d": "16",
    "superdelegates_r": "",
    "superdelegates_d": "10",
    "state_short": "VT",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "0",
    "Bernie Sanders": "16",
    "Donald Trump": "8",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "8",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Virginia",
    "delegates_r": "49",
    "delegates_d": "95",
    "superdelegates_r": "",
    "superdelegates_d": "14",
    "state_short": "VA",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "62",
    "Bernie Sanders": "33",
    "Donald Trump": "17",
    "Ben Carson": "3",
    "Ted Cruz": "8",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "5",
    "Rand Paul": "",
    "Marco Rubio": "16",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "1 mar",
    "state": "Demokrater utomlands",
    "delegates_r": "",
    "delegates_d": "13",
    "superdelegates_r": "",
    "superdelegates_d": "4",
    "state_short": "DA",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "4",
    "Bernie Sanders": "9",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "D",
    "text": ""
  },
  {
    "date": "5 mar",
    "state": "Kentucky",
    "delegates_r": "46",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "KY",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "17",
    "Ben Carson": "",
    "Ted Cruz": "15",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "7",
    "Rand Paul": "",
    "Marco Rubio": "7",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "R",
    "text": ""
  },
  {
    "date": "5 mar",
    "state": "Louisiana",
    "delegates_r": "46",
    "delegates_d": "51",
    "superdelegates_r": "",
    "superdelegates_d": "8",
    "state_short": "LA",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "37",
    "Bernie Sanders": "14",
    "Donald Trump": "25",
    "Ben Carson": "",
    "Ted Cruz": "18",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "5 mar",
    "state": "Nebraska",
    "delegates_r": "",
    "delegates_d": "25",
    "superdelegates_r": "",
    "superdelegates_d": "5",
    "state_short": "NE",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "10",
    "Bernie Sanders": "15",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "5 mar",
    "state": "Kansas",
    "delegates_r": "40",
    "delegates_d": "33",
    "superdelegates_r": "",
    "superdelegates_d": "4",
    "state_short": "KS",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "10",
    "Bernie Sanders": "23",
    "Donald Trump": "9",
    "Ben Carson": "",
    "Ted Cruz": "24",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "1",
    "Rand Paul": "",
    "Marco Rubio": "6",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "B",
    "text": ""
  },
  {
    "date": "5 mar",
    "state": "Maine",
    "delegates_r": "23",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "ME",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "9",
    "Ben Carson": "",
    "Ted Cruz": "12",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "2",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "R",
    "text": ""
  },
  {
    "date": "6 mar",
    "state": "Maine",
    "delegates_r": "",
    "delegates_d": "25",
    "superdelegates_r": "",
    "superdelegates_d": "5",
    "state_short": "ME",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "8",
    "Bernie Sanders": "17",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "6 mar",
    "state": "Puerto Rico",
    "delegates_r": "23",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "PR",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "23",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "R",
    "text": ""
  },
  {
    "date": "8 mar",
    "state": "Hawaii",
    "delegates_r": "19",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "HI",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "11",
    "Ben Carson": "",
    "Ted Cruz": "7",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "1",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "R",
    "text": ""
  },
  {
    "date": "8 mar",
    "state": "Idaho",
    "delegates_r": "32",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "ID",
    "done": "DONE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "12",
    "Ben Carson": "",
    "Ted Cruz": "20",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "R",
    "text": ""
  },
  {
    "date": "8 mar",
    "state": "Michigan",
    "delegates_r": "59",
    "delegates_d": "130",
    "superdelegates_r": "",
    "superdelegates_d": "17",
    "state_short": "MI",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "63",
    "Bernie Sanders": "67",
    "Donald Trump": "25",
    "Ben Carson": "",
    "Ted Cruz": "17",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "17",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "8 mar",
    "state": "Mississippi",
    "delegates_r": "40",
    "delegates_d": "36",
    "superdelegates_r": "",
    "superdelegates_d": "5",
    "state_short": "MS",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "31",
    "Bernie Sanders": "5",
    "Donald Trump": "25",
    "Ben Carson": "",
    "Ted Cruz": "15",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "10 mar",
    "state": "Amerikanska Jungruöarna",
    "delegates_r": "4",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "VI",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "1",
    "Ben Carson": "",
    "Ted Cruz": "1",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "2",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "R",
    "text": ""
  },
  {
    "date": "12 mar",
    "state": "District of Columbia",
    "delegates_r": "19",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "DC",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "9",
    "Rand Paul": "",
    "Marco Rubio": "10",
    "Mike Huckabee": "",
    "kind": "CO",
    "party": "R",
    "text": ""
  },
  {
    "date": "12 mar",
    "state": "Nordmarianerna",
    "delegates_r": "",
    "delegates_d": "6",
    "superdelegates_r": "",
    "superdelegates_d": "5",
    "state_short": "MP",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "4",
    "Bernie Sanders": "2",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "12 mar",
    "state": "Wyoming",
    "delegates_r": "26",
    "delegates_d": "",
    "superdelegates_r": "3",
    "superdelegates_d": "",
    "state_short": "WY",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "1",
    "Ben Carson": "",
    "Ted Cruz": "23",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "1",
    "Mike Huckabee": "",
    "kind": "CO",
    "party": "R",
    "text": "Republikanerna utsåg tolv delegater i Wyoming den 12 mars. Resten kommer att väljas på ett delstatskonvent den 16 april."
  },
  {
    "date": "15 mar",
    "state": "Florida",
    "delegates_r": "99",
    "delegates_d": "214",
    "superdelegates_r": "",
    "superdelegates_d": "32",
    "state_short": "FL",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "141",
    "Bernie Sanders": "73",
    "Donald Trump": "99",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "15 mar",
    "state": "Illinois",
    "delegates_r": "69",
    "delegates_d": "156",
    "superdelegates_r": "",
    "superdelegates_d": "26",
    "state_short": "IL",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "79",
    "Bernie Sanders": "77",
    "Donald Trump": "54",
    "Ben Carson": "",
    "Ted Cruz": "9",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "6",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "15 mar",
    "state": "Missouri",
    "delegates_r": "52",
    "delegates_d": "71",
    "superdelegates_r": "",
    "superdelegates_d": "13",
    "state_short": "MO",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "36",
    "Bernie Sanders": "35",
    "Donald Trump": "37",
    "Ben Carson": "",
    "Ted Cruz": "15",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "15 mar",
    "state": "North Carolina",
    "delegates_r": "72",
    "delegates_d": "107",
    "superdelegates_r": "",
    "superdelegates_d": "14",
    "state_short": "NC",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "60",
    "Bernie Sanders": "47",
    "Donald Trump": "29",
    "Ben Carson": "",
    "Ted Cruz": "27",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "9",
    "Rand Paul": "",
    "Marco Rubio": "6",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "15 mar",
    "state": "Nordmarianerna",
    "delegates_r": "9",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "MP",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "9",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "R",
    "text": ""
  },
  {
    "date": "15 mar",
    "state": "Ohio",
    "delegates_r": "66",
    "delegates_d": "143",
    "superdelegates_r": "",
    "superdelegates_d": "17",
    "state_short": "OH",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "81",
    "Bernie Sanders": "62",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "66",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "22 mar",
    "state": "Arizona",
    "delegates_r": "58",
    "delegates_d": "75",
    "superdelegates_r": "",
    "superdelegates_d": "10",
    "state_short": "AZ",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "42",
    "Bernie Sanders": "33",
    "Donald Trump": "58",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "22 mar",
    "state": "Idaho",
    "delegates_r": "",
    "delegates_d": "23",
    "superdelegates_r": "",
    "superdelegates_d": "4",
    "state_short": "ID",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "5",
    "Bernie Sanders": "18",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "22 mar",
    "state": "Utah",
    "delegates_r": "40",
    "delegates_d": "33",
    "superdelegates_r": "",
    "superdelegates_d": "4",
    "state_short": "UT",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "6",
    "Bernie Sanders": "27",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "40",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "26 mar",
    "state": "Alaska",
    "delegates_r": "",
    "delegates_d": "16",
    "superdelegates_r": "",
    "superdelegates_d": "4",
    "state_short": "AK",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "3",
    "Bernie Sanders": "13",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "26 mar",
    "state": "Hawaii",
    "delegates_r": "",
    "delegates_d": "25",
    "superdelegates_r": "",
    "superdelegates_d": "10",
    "state_short": "HI",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "8",
    "Bernie Sanders": "17",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "26 mar",
    "state": "Delstaten Washington",
    "delegates_r": "",
    "delegates_d": "101",
    "superdelegates_r": "",
    "superdelegates_d": "17",
    "state_short": "WA",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "27",
    "Bernie Sanders": "74",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "5 apr",
    "state": "Wisconsin",
    "delegates_r": "42",
    "delegates_d": "89",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "WI",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "38",
    "Bernie Sanders": "48",
    "Donald Trump": "6",
    "Ben Carson": "",
    "Ted Cruz": "36",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "9 apr",
    "state": "Wyoming",
    "delegates_r": "29",
    "delegates_d": "17",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "WY",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "7",
    "Bernie Sanders": "7",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": "",
    "winner_d": "Bernie Sanders"
  },
  {
    "date": "19 apr",
    "state": "New York",
    "delegates_r": "95",
    "delegates_d": "247",
    "superdelegates_r": "",
    "superdelegates_d": "44",
    "state_short": "NY",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "139",
    "Bernie Sanders": "108",
    "Donald Trump": "89",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "6",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "26 apr",
    "state": "Maryland",
    "delegates_r": "38",
    "delegates_d": "101",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "MD",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "60",
    "Bernie Sanders": "35",
    "Donald Trump": "38",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "26 apr",
    "state": "Connecticut",
    "delegates_r": "28",
    "delegates_d": "65",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "CT",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "28",
    "Bernie Sanders": "27",
    "Donald Trump": "28",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "26 apr",
    "state": "Delaware",
    "delegates_r": "16",
    "delegates_d": "27",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "DE",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "12",
    "Bernie Sanders": "9",
    "Donald Trump": "16",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "26 apr",
    "state": "Pennsylvania",
    "delegates_r": "71",
    "delegates_d": "176",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "PA",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "106",
    "Bernie Sanders": "83",
    "Donald Trump": "17",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "26 apr",
    "state": "Rhode Island",
    "delegates_r": "19",
    "delegates_d": "31",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "RI",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "11",
    "Bernie Sanders": "13",
    "Donald Trump": "12",
    "Ben Carson": "",
    "Ted Cruz": "2",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "5",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "3 maj",
    "state": "Indiana",
    "delegates_r": "57",
    "delegates_d": "83",
    "superdelegates_r": "",
    "superdelegates_d": "9",
    "state_short": "IN",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "39",
    "Bernie Sanders": "44",
    "Donald Trump": "57",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "7 maj",
    "state": "Guam",
    "delegates_r": "9",
    "delegates_d": "11",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "GU",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "4",
    "Bernie Sanders": "3",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "10 maj",
    "state": "Nebraska",
    "delegates_r": "36",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "NE",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "36",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "R",
    "text": ""
  },
  {
    "date": "10 maj",
    "state": "West Virginia",
    "delegates_r": "34",
    "delegates_d": "34",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "WV",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "11",
    "Bernie Sanders": "18",
    "Donald Trump": "30",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "1",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "17 maj",
    "state": "Kentucky",
    "delegates_r": "",
    "delegates_d": "53",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "KY",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "28",
    "Bernie Sanders": "27",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "D",
    "text": ""
  },
  {
    "date": "17 maj",
    "state": "Oregon",
    "delegates_r": "28",
    "delegates_d": "67",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "OR",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "25",
    "Bernie Sanders": "36",
    "Donald Trump": "18",
    "Ben Carson": "",
    "Ted Cruz": "5",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "5",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "24 maj",
    "state": "Delstaten Washington",
    "delegates_r": "44",
    "delegates_d": "",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "WA",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "",
    "Bernie Sanders": "",
    "Donald Trump": "40",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "R",
    "text": ""
  },
  {
    "date": "4 jun",
    "state": "Amerikanska Jungruöarna",
    "delegates_r": "",
    "delegates_d": "11",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "VI",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "7",
    "Bernie Sanders": "",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "5 jun",
    "state": "Puerto Rico",
    "delegates_r": "",
    "delegates_d": "58",
    "superdelegates_r": "",
    "superdelegates_d": "",
    "state_short": "PR",
    "done": "TRUE",
    "ongoing": "",
    "Hillary Clinton": "36",
    "Bernie Sanders": "24",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "7 jun",
    "state": "Kalifornien",
    "delegates_r": "172",
    "delegates_d": "475",
    "superdelegates_r": "",
    "superdelegates_d": "75",
    "state_short": "CA",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "269",
    "Bernie Sanders": "206",
    "Donald Trump": "172",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "7 jun",
    "state": "Montana",
    "delegates_r": "27",
    "delegates_d": "21",
    "superdelegates_r": "",
    "superdelegates_d": "6",
    "state_short": "MT",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "10",
    "Bernie Sanders": "11",
    "Donald Trump": "27",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "7 jun",
    "state": "New Jersey",
    "delegates_r": "51",
    "delegates_d": "126",
    "superdelegates_r": "",
    "superdelegates_d": "16",
    "state_short": "NJ",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "79",
    "Bernie Sanders": "47",
    "Donald Trump": "51",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "7 jun",
    "state": "New Mexico",
    "delegates_r": "24",
    "delegates_d": "34",
    "superdelegates_r": "",
    "superdelegates_d": "9",
    "state_short": "NM",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "18",
    "Bernie Sanders": "16",
    "Donald Trump": "24",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "7 jun",
    "state": "North Dakota",
    "delegates_r": "28",
    "delegates_d": "18",
    "superdelegates_r": "",
    "superdelegates_d": "5",
    "state_short": "ND",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "5",
    "Bernie Sanders": "13",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "C",
    "party": "D",
    "text": ""
  },
  {
    "date": "7 jun",
    "state": "South Dakota",
    "delegates_r": "29",
    "delegates_d": "20",
    "superdelegates_r": "",
    "superdelegates_d": "5",
    "state_short": "SD",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "10",
    "Bernie Sanders": "10",
    "Donald Trump": "29",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "B",
    "text": ""
  },
  {
    "date": "14 jun",
    "state": "District of Columbia",
    "delegates_r": "",
    "delegates_d": "20",
    "superdelegates_r": "",
    "superdelegates_d": "26",
    "state_short": "DC",
    "done": "true",
    "ongoing": "",
    "Hillary Clinton": "16",
    "Bernie Sanders": "4",
    "Donald Trump": "",
    "Ben Carson": "",
    "Ted Cruz": "",
    "Jeb Bush": "",
    "Carly Fiorina": "",
    "John Kasich": "",
    "Rand Paul": "",
    "Marco Rubio": "",
    "Mike Huckabee": "",
    "kind": "P",
    "party": "D",
    "text": ""
  }
];



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/data.js
 **/